import { handleRequest } from "../utilities/requestHandler";

export const getProductsById = (products, siteNumber, cusId) =>
    handleRequest("post", "/products/byids", {
        products: products,
        site_number: siteNumber,
        ...(cusId !== undefined && cusId !== null ? { cus_id: cusId } : {}),
    });

export const getCartProductSummaries = (products, siteNumber, cusId) =>
    handleRequest("post", "/products/byids/cart-summary", {
        products: products,
        site_number: siteNumber,
        ...(cusId !== undefined && cusId !== null ? { cus_id: cusId } : {}),
    });

export const getOptions = () =>
    handleRequest("get", "/options");

export const getCartRecommendations = (productIds, siteNumber, cus_id, site_id) =>
    handleRequest("post", "/orders/getCartRecommendations", {
        products: productIds,
        site_number: siteNumber,
        ...(cus_id ? { cus_id } : {}),
        ...(site_id ? { site_id } : {}),
    });

export const getUserCart = (userId) =>
    handleRequest("post", "/cart/getCart", { userId });

export const updateUserCart = (userId, cart) =>
    handleRequest("post", "/cart", { userId, cart });

export const getCartCTP = (requestBody) =>
    handleRequest("post", "/erp/getCartCTP", requestBody);

export const addModelCartItems = (payload) =>
    handleRequest("post", "/cart/model_add_to_cart", payload);
